export default function Final() {
    return (
        <div
            style={{
                backgroundColor: "#2b2b2b",
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: 0,
            }}
        >
            <video
                src="/Batman.mp4"
                controls
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                }}
            />
        </div>
    );
}
